IREP.wysiwyg = (function () {
    var options;
    var wysiwygEditor;
    var saveElement;
    var cancelElement;

    var init = function (wysiwygOptions) {
        options = wysiwygOptions;

        setupWYSIWYG(options.wysiwygId);
        show(true);

        return this;
    };

    var updateSaveFunction = function (saveFunction) {
        options.saveFunction = saveFunction; 
    }

    var show = function (addPadding) {
        options.container.slideDown({
            done: function () {
                if (addPadding) {
                    $("#content").css("padding-bottom", "+=" + options.additionalPadding);
                }
            }
        });
    };

    var setupWYSIWYG = function (wysiwygId) {
        var wysiwyg = $("#" + wysiwygId);

        if (wysihtml5.commands.superscript === undefined) {
            wysihtml5.commands.superscript = {
                exec: function (composer, command) {
                    return wysihtml5.commands.formatInline.exec(composer, command, "sup");
                },

                state: function (composer, command) {
                    return wysihtml5.commands.formatInline.state(composer, command, "sup");
                }
            };
        }

        if (wysihtml5.commands.strikethrough === undefined) {
            wysihtml5.commands.strikethrough = {
                exec: function (composer, command) {
                    return wysihtml5.commands.formatInline.exec(composer, command, "s");
                },

                state: function (composer, command) {
                    return wysihtml5.commands.formatInline.state(composer, command, "s");
                }
            };
        }

        var toolbar = createToolbar(wysiwygId, [
            createGroup("WysiwygTextEffects", [
                createButton("CTRL+B", "bold", "Bold_666666.png"),
                createButton("CTRL+I", "italic", "Italic_666666.png"),
                createButton("Superscript", "superscript", "Super_666666.png"),
                createButton("Strikethrough", "strikethrough", "Strike_666666.png")
            ]),
            createGroup("WysiwygImageEffects", [
                createButton("Insert Image", "insertImage", "InsertPic_666666.png"),
                createButton("Insert Link", "createLink", "InsertLink_666666.png")
            ]),
            createGroup("WysiwygListEffects", [
                createButton("Unordered List", "insertUnorderedList", "UO_list_666666.png"),
                createButton("Ordered List", "insertOrderedList", "Ordered_list_666666.png")
            ]),
            $("<div>")
                .attr({ "data-wysihtml5-dialog": "createLink" })
                .css({ display: "none" })
                .append(
                    $("<label>")
                        .append("Link:")
                        .append(
                            $("<input  id='insertLinkTxtUrlField'>")
                                .attr({ "data-wysihtml5-dialog-field": "href" })
                                .attr({ value: "http://" })
                        )
                )
                .append(
                    $("<a id='insertLinkBtnOk'>")
                        .addClass("btn")
                        .attr({ "data-wysihtml5-dialog-action": "save" })
                        .text("OK")
                )
                .append(
                    $("<a id='insertLinkBtnCancel'>")
                        .addClass("btn")
                        .attr({ "data-wysihtml5-dialog-action": "cancel" })
                        .text("Cancel")
                ),
            $("<div>")
                .attr({ "data-wysihtml5-dialog": "insertImage" })
                .css({ display: "none" })
                .append(
                    $("<label>")
                        .append("Image:")
                        .append($("<input id='insertImageTxtUrlField'>")
                            .attr({ "data-wysihtml5-dialog-field": "src" })
                            .attr({ value: "http://" })
                        )
                )
                .append(
                    $("<a id='insertImageBtnOk'>")
                        .addClass("btn")
                        .attr({ "data-wysihtml5-dialog-action": "save" })
                        .text("OK")
                )
                .append(
                    $("<a id='insertImageBtnCancel'>")
                        .addClass("btn")
                        .attr({ "data-wysihtml5-dialog-action": "cancel" })
                        .text("Cancel")
                )
        ]);
        wysiwyg.before(toolbar);

        saveElement = wysiwyg.siblings("#submit");
        cancelElement = wysiwyg.siblings("a[type='reset']");
        
        saveElement.on("click", {showSuccess: true}, save);
        cancelElement.on("click", {showSuccess: false}, reset);
        
        wysiwygEditor = new wysihtml5.Editor(wysiwygId, {
            toolbar: toolbar.prop("id"),
            parserRules: wysihtml5ParserRules,
            useLineBreaks: false,
            stylesheets: [IREP.options.appUrl + "content/styles/wysiwyg/wysiwyg.css"]
        });
    };

    var save = function (event) {
        options.container.find(".error").remove();
        saveElement.addClass("disabled");
        options.saveFunction(function() { reset(event); }, function() { resetFailure(); });
        return false;
    };

    var reset = function (event) {
        if (event.data.showSuccess) {
            showStatusMessage(options.successText, "success");
        }
        wysiwygEditor.clear();
        saveElement.removeClass("disabled");
        options.container.slideUp();
        return false;
    };

    var resetFailure = function () {
        showStatusMessage(options.failureText, "error");
        saveElement.removeClass("disabled");
        return false;
    };

    var showStatusMessage = function (statusMessage, cssClass) {
        var statusElement = $("<div class='" + cssClass + "'>" + statusMessage + "</div>");
        options.container.append(statusElement);
    };

    var createToolbar = function (wysiwygId, groups) {
        var toolbar = $("<div>")
            .prop("id", wysiwygId + "-toolbar")
            .addClass("toolbar")
            .css("display", "none");
        $.each(groups, function (index, item) { item.appendTo(toolbar); });
        return toolbar;
    };

    var createGroup = function (name, items) {
        var group = $("<div id='" + name + "'>").addClass("btn-group");
        $.each(items, function (index, item) { item.appendTo(group); });
        return group;
    };

    var createButton = function (title, command, image) {
        return $("<img>").addClass("btn").prop({ title: title }).attr({ "data-wysihtml5-command": command, src: IREP.options.appUrl + "content/images/forum/51/" + image });
    };

    var getEditor = function () {
        return wysiwygEditor; 
    };

    return {
        init: init,
        updateSaveFunction: updateSaveFunction,
        show: show,
        editObject: getEditor
    };
})();